var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2752_4062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 6.49982C40.2 6.49982 42 8.29982 42 10.4998V38.4998C42 40.6998 40.2 42.4998 38 42.4998H10C7.8 42.4998 6 40.6998 6 38.4998V10.4998C6 8.29982 7.8 6.49982 10 6.49982L24.3916 6.49928C24.1398 7.0483 24 7.65532 24 8.29376V22.2332C24 25.6232 26.8625 28.3665 30.4 28.3665C33.9375 28.3665 36.8 25.6232 36.8 22.2332V9.40891H35.0545V22.2332C35.0545 24.6976 32.9716 26.6938 30.4 26.6938C27.8284 26.6938 25.7455 24.6976 25.7455 22.2332V8.29376C25.7455 7.61033 26.0025 6.98409 26.4289 6.49902H30.8802C31.3066 6.98409 31.5636 7.61033 31.5636 8.29376V20.0029C31.5636 20.6162 31.04 21.118 30.4 21.118C29.76 21.118 29.2364 20.6162 29.2364 20.0029V9.40891H27.4909V20.0029C27.4909 21.5418 28.7942 22.7907 30.4 22.7907C32.0058 22.7907 33.3091 21.5418 33.3091 20.0029V8.29376C33.3091 7.65532 33.1693 7.0483 32.9174 6.49928L38 6.49982Z",
    fill: "#4C5E6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2752_4062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFileUpload);
export default __webpack_public_path__ + "static/media/icons_file_upload.f64a15fb.svg";
export { ForwardRef as ReactComponent };